import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { Link, useNavigate } from "react-router-dom";
import AdditionalProfileCreatedModal from "./modals/AdditionalProfileCreatedModal";
import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import UploadTempImageModal from "./modals/UploadTempImageModal";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";
import DeleteTempImgModal from "./modals/DeleteTempImgModal";
import SideMenu from "../../components/SideMenu";

export default function AddProfile({ goBack, fetchData }) {
  const {user} = useAuthContext()
  const [firstName, setFirstName] = useState("");
  const [firstNameErr, setFirstNameErr] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameErr, setLastNameErr] = useState("");
  const [username, setUsername] = useState("");
  const [usernameErr, setUsernameErr] = useState("");
  const [profile, setProfile] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [completeModal, setCompleteModal] = useState(false);
  const [registerErr, setRegisterErr] = useState("");
  const [uploadProfileImgModal, setUploadProfileImgModal] = useState(false);
  const [deleteImgModal, setDeleteImgModal] = useState(false);


  const [tempImgExists, setTempImgExists] = useState(false);

  const [previewUrl, setPreviewUrl] = useState(null);

  const passDownData = (url) => {
    setPreviewUrl(url);
  };

  const imgDeleted = () => {
    setTempImgExists(false);
    setPreviewUrl(null);
  };

  const fetchImg = async () => {
    const tempImgResponse = await axios.get(
      `${ApiConnectionString}/api/TempImageExists/`,
      {
        headers: { Authorization: `bearer ${user.token}` },
      }
    );
    if (tempImgResponse.status == 200) {
      setTempImgExists(tempImgResponse.data);
    }
  };

  useEffect(() => {
    fetchImg();
  }, [uploadProfileImgModal,user]);

  const cancelModal = () => {
    setUploadProfileImgModal(false);
    setDeleteImgModal(false);
  };

  const usernameRegex = /^[\w\d\s-']+$/;
  const nameRegex = /^[A-Za-z\s-']+$/;



  const complete = () => {
    setCompleteModal(false);
    fetchData();
    goBack();
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let err = false;
    setUsernameErr("");
    setFirstNameErr("");
    setLastNameErr("");
    setRegisterErr(" ");

    // Username Validations
    if (username.length < 3) {
      err = true;
      setUsernameErr(
        "Username is too short. It must be at least 3 characters long"
      );
    }
    if (username.length > 15) {
      err = true;
      setUsernameErr("Username is too long. It must not be over 15 characters");
    }
    if (!usernameRegex.test(username)) {
      err = true;
      setUsernameErr(
        "Your username can only include letters, numbers, spaces, hyphens, underscores, and apostrophes."
      );
    }
    // First Name Validations
    if (!nameRegex.test(firstName)) {
      err = true;
      setFirstNameErr(
        "Your first name can only include letters, spaces, hyphens, underscores, and apostrophes."
      );
    }
    if (firstName.length < 2) {
      err = true;
      setFirstNameErr(
        "Your first name is too short. It must be at least 2 characters long"
      );
    }
    if (firstName.length > 50) {
      err = true;
      setFirstNameErr(
        "Your first name is too long. It must not be over 50 characters"
      );
    }

    // Last Name Validations
    if (!nameRegex.test(lastName)) {
      err = true;
      setLastNameErr(
        "Your last name can only include letters, spaces, hyphens, underscores, and apostrophes."
      );
    }
    if (lastName.length < 2) {
      err = true;
      setLastNameErr(
        "Your last name is too short. It must be at least 2 characters long"
      );
    }
    if (lastName.length > 50) {
      err = true;
      setLastNameErr(
        "Your last name is too long. It must not be over 50 characters"
      );
    }

    if (!err) {
      const createBookingProfile = { firstName, lastName, username };

      try {
        const profileResponse = await axios.post(
          `${ApiConnectionString}/api/bookingProfile`,
          createBookingProfile,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (profileResponse.status === 200) {
          setProfile(profileResponse.data);
          setCompleteModal(true);
        }
      } catch (error) {
        if (error.response && error.response.status == 400) {
          // Use the error response data directly
          setRegisterErr(error.response.data);
        } else {
          // Handle other types of errors or unexpected responses
          setRegisterErr(
            "An unexpected error occurred. Please try again later."
          );
        }
      } finally {
        // Stop loading regardless of success or failure
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div className="container">
        <p className="btn btn-primary" onClick={goBack}>
          Go back
        </p>

        <div className="row">
          <div className="col-3 side-menu-container">
            <SideMenu />
          </div>
          <div className="col bg-white mx-5 my-2 p-0 ">
            <div className="blueBanner d-flex align-items-center">
              <p className="text-white p-2 mx-3 fw-bold fontSize20">
                Add A Profile
              </p>
              <p className="text-white   fw-bold fontSize14">
                (Add up to 8 additional profiles)
              </p>
            </div>
            <div className="text-center">
            <div className="d-flex justify-content-center mt-4">
              {tempImgExists ? (
                <img
                  src={
                    previewUrl !== null
                      ? previewUrl
                      : `${ApiConnectionString}/api/TempImage/${user.id}`
                  }
                  alt="Image Preview"
              
                  className="circle-crop"
                />
              ) : (
                <img
                  className="circle-crop"
                  src={ProfilePlaceHolder}
                />
              )}
              </div>
              <br></br>
              <div className="d-flex justify-content-center">
              {!tempImgExists ? (
                <button
                  onClick={() => {
                    setUploadProfileImgModal(true);
                  }}
                  className="profile-blue-button mt-0"
                ><Link>Add an image</Link>
                  
                </button>
              ) : (
                <div>
                    <button
                  onClick={() => {
                    setUploadProfileImgModal(true);
                  }}
                  className="profile-blue-button mt-0"
                ><Link>Change Image</Link>
                  
                </button>
                  <button
                    onClick={() => setDeleteImgModal(true)}
                    className="profile-delete-button mx-3"
                  ><Link>
                    Delete Image
                  </Link>
                  
                  </button>
                </div>
              )}
              </div>
              <div className="d-flex justify-content-center">
              <hr className="w-75" />
            </div>

              <form onSubmit={handleSubmit} className="mt-3">
                <div>
                  <label>
                    First Name:
                    <input
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </label>
                  {firstNameErr && (
                    <p className="text-danger">{firstNameErr}</p>
                  )}
                </div>
                <div className="d-flex justify-content-center">
              <hr className="w-75" />
            </div>
                <div>
                  <label>
                    Last Name:
                    <input
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </label>
                  {lastNameErr && <p className="text-danger">{lastNameErr}</p>}
                </div>
                <div className="d-flex justify-content-center">
              <hr className="w-75" />
            </div>
                <div>
                  <label>
                    Username:
                    <input
                      type="text"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </label>
                  {usernameErr && <p className="text-danger">{usernameErr}</p>}
                </div>
                <div className="d-flex justify-content-center">
              <hr className="w-75" />
            </div>
                <button className="saveChanges-button mb-2" type="submit">
                  <a className="fw-bold">Create Profile</a>
                </button>
              </form>
              {registerErr && <p className="text-danger">{registerErr}</p>}

              {completeModal && (
                <AdditionalProfileCreatedModal
                  profile={profile}
                  complete={complete}
                />
              )}

              {uploadProfileImgModal && (
                <UploadTempImageModal
                  cancelModal={cancelModal}
                  passDownData={passDownData}
                />
              )}
              {deleteImgModal && (
                <DeleteTempImgModal
                  imgDeleted={imgDeleted}
                  cancelModal={cancelModal}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
